<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Monitoring IP (Suspect)</h5>
            </template>
            <div class="filter-form-wrapper mb-3">
                <b-row>
                    <b-col md="12" lg="12" xl="6">
                        <b-form-group class="form-inline filter-form-date" label-for="filterDate" label="Tanggal">
                            <div class="d-flex search-input-wrapper">
                                <b-form-input
                                    v-model="input.filterFromDate" name="filterFromDate"
                                    id="filterDate"
                                    type="date"
                                ></b-form-input>
                                <span class="ml-2 mr-2 d-flex align-items-center">s/d</span>
                                <b-form-input 
                                    v-model="input.filterToDate" name="filterToDate"
                                    type="date"
                                ></b-form-input>
                            </div>
                        </b-form-group>
						<b-form-group class="form-inline" label-for="filterCabang" label="Cabang">
                            <div label="Filter Cabang">
                                <multiselect
                                class="ml-0"
                                    name="filterCabang"
                                    v-model="input.filterCabang" 
                                    :options="cabangOption" 
                                    :internal-search="true"
                                    :allow-empty="true"
                                    deselect-label=""
                                    select-label=""
                                    label="name"
                                    track-by="name"
                                    placeholder="-- Pilih filter cabang --"
                                />
                            </div>
                        </b-form-group>
                        <b-form-group class="form-inline" label-for="filterStatus" label="Status">
                            <b-form-select v-model="input.filterStatus" id="filterStatus" name="status" :options="status" value-field="id" text-field="name">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>Status</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
						<b-form-group class="form-inline" label-for="filterLogin" label="Login">
                            <b-form-select v-model="input.filterLogin" id="filterLogin" name="login" :options="loginOption" value-field="id" text-field="name">
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <div class="filter-btn-wrapper">
                            <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter"> 
                                Search 
                            </b-button>
                            <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="dataMonitoringIp" 
                :fields="fields" 
                :no-local-sorting="false"
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data monitoring ip.
                </template>
                <template v-slot:cell(time)="row">
                    <div>{{$helper.changeDateFormat(row.item.time)}}</div>
                    <div class="smallText text-muted">{{$helper.changeDateFormatGetHour(row.item.time)}}</div>
                </template>
                <template v-slot:cell(user)="row">
                    <div>
                        <div class="no-wrap">
							<span class="mb-0">{{row.item.fullname}}</span> 
							<i class="fa fa-info tooltip-trigger-btn ml-1" v-b-tooltip.hover title="User Log" @click="getUserLog(row.item.userId)"/>
						</div>
                        <p class="mb-0 smallText text-muted">{{row.item.cabang}} - {{row.item.role}}</p>
                    </div>
                </template>
                <template v-slot:cell(ip)="row">
                    <p class="mb-0">{{row.item.ip}}</p>
                </template>
				<template v-slot:cell(success)="row">
					<i class="fa fa-check log-success" v-if="row.item.success == true" ></i>
					<i class="fa fa-times log-failed" v-else></i>
				</template>
                <template v-slot:cell(status)="row">
                    <b-badge variant="primary" v-if="row.item.markRead == false">BARU</b-badge>
                    <b-badge variant="success" v-else>DIBACA</b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <div v-if="row.item.markRead == false" class="no-wrap">
						<b-button size="sm" variant="pgiBtn" name="tandaiBaca" @click="confirmRead(row.item.id)">
							Tandai Dibaca
						</b-button>
                    </div>
                </template>
            </b-table>

            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                    @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>
		<b-modal id="modal-user-log" class="modal-big-size" size="xl" @hidden="resetModal" centered title="User Log" hide-footer no-close-on-backdrop>
            <div class="text-center" v-if="isLoadingLog == true">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div v-else>
                <div class="search-wrapper d-flex align-items-center justify-content-between">
                    <b-form-group
                        label="Filter"
                        label-for="filterInput"
                        class="form-inline form-group-wrapper mb-3"
                    >
                        <div class="d-flex search-input-wrapper">
                            <b-form-input class="ml-2 mr-2"
                                v-model="filterFromDateUserLog" name="filterFromDateUserLog"
                                id="filterInput"
                                type="date"
                            ></b-form-input>
                            <span class="mr-2 d-flex align-items-center">to</span>
                            <b-form-input class="mr-2" 
                                v-model="filterToDateUserLog" name="filterToDateUserLog"
                                type="date"
                            ></b-form-input>
                            <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilterUserLog"> 
                                <i class="fa fa-search"></i>
                            </b-button>
                            <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onResetUserLog">Reset</b-button>
                        </div>
                    </b-form-group>
                </div>
                <b-table bordered hover show-empty
                    :busy="isBusy"
                    :items="dataLog" 
                    :fields="fieldsUserLog"
                    responsive class="mb-3">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>  Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada data log.
                    </template>
                    <template v-slot:cell(index)="data">
                        {{ data.index + 1 }}
                    </template>
                    <template v-slot:cell(time)="row">
                        <div>{{$helper.changeDateFormat(row.item.time)}} {{$helper.changeDateFormatGetHour(row.item.time)}}</div>
                    </template>
                    <template v-slot:cell(success)="row">
                        <div class="no-wrap">
							<i class="fa fa-check log-success" v-if="row.item.success == true" ></i>
							<i class="fa fa-times log-failed" v-else></i>
							<b-badge class="ml-2" variant="danger" v-if="row.item.suspect == true">Suspect</b-badge>
						</div>
                    </template>
                </b-table>

                <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                    <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                        <b-form-select v-model="input.showUserLog" id="showItems" :options="options" @change="onLimitChangeUserLog">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled />
                            </template>
                        </b-form-select>
                        <span class="ml-2">{{ totalViewTextUserLog }}</span>
                    </b-input-group>
                    <b-pagination class="mb-0"
                        v-model="currentPageUserLog"
                        :total-rows="rowsUserLog"
                        :per-page="perPageUserLog"
                        aria-controls="my-table"
                        @input="onPageUserLogChange"
                    ></b-pagination>
                </div>
            </div>
        </b-modal>
		<ModalConfirm id="modal-confirm-markAsRead" title="Confirm Baca Monitoring" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menandai monitoring ini sudah dibaca?" @submit="onSubmit" />
    </div>
</template>

<script>
export default {
    name: 'monitoring-ip',
    data(){
        return{
            initStatus: 0,
            isSubmitting: false,
			isBusy: true,
			isLoadingLog: false,
            input:{
                show: 10,
                showUserLog: 10,
                filterCabang: null,
                filterStatus: null,
                filterFromDate: null,
				filterToDate: null,
				filterLogin: null,
            },
            fields: [
                { key: "time", label: "Tanggal"},
                { key: "user", label: "User" },
				{ key: "ip", label: "IP Address"},
				{ key: "success", label: "Login Sukses"},
                { key: "status", label: "Status"},
                { key: "action", label: "Aksi" },
			],
			fieldsUserLog: [
                { key: "index", label: "No. ", tdClass: "indexNo" },
                { key: "time", label: "Tanggal"},
                { key: "ip", label: "IP Address"},
                { key: "success", label: "Sukses"},
            ],
            filter: null,
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
			],
			loginOption: [
				{id: null, name: 'Semua'},
				{id: true, name: 'Sukses'},
                {id: false, name: 'Gagal'}
			],
            cabangOption: [],
            status: [
                {id: 0, name: 'BARU'},
                {id: 1, name: 'DIBACA'}
            ],
            dataMonitoringIp: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            cabangId: '',
            loading: false,
			query: "",
			activeId: null,

			//userlog
			
            dataLog: [],
			filterFromDateUserLog: null,
            filterToDateUserLog: null,
            currentPageUserLog: 1,
            perPageUserLog: 10,
            rowsUserLog: null,
            totalViewTextUserLog: "",
            pageUserLog: '',
            sizeUserLog: '',
			queryUserLog: "",
			activeUserLogId: 1
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){

            this.initStatus = 0
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)

            let getCabang = this.$axios.get("cabang/all-selection").then(response => {
                response.data.forEach((element) => {
                    if(element.id != this.srcCabangId)
                        this.cabangOption.push(element)
                })
            })

            let getDataMonitoring = this.$axios.get("monitoring-ip/"+this.query).then(response => {
                this.dataMonitoringIp = response.data.data
                
                this.updateTotalItem(response.data.total)
            })

				Promise.all([getCabang, getDataMonitoring]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
                this.toggleBusy()
            })
        },

        //----------------- Fungsi Ambil Data Daftar Gadai -----------------

        getDataMonitoring(){
            this.toggleBusy()
            this.dataMonitoringIp = []

            if (this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)) this.query = this.query + "&filterStart=" + this.input.filterFromDate
            if (this.$helper.isNotNullAndNotEmpty(this.input.filterToDate)) this.query = this.query + "&filterEnd=" + this.input.filterToDate
            if (this.input.filterCabang != null) this.query = this.query + "&filterCabang=" + this.input.filterCabang.id
            if (this.input.filterStatus != null) this.query = this.query + "&filterStatus=" + this.input.filterStatus
            if (this.input.filterLogin != null) this.query = this.query + "&filterLogin=" + this.input.filterLogin
            
            this.$axios.get("monitoring-ip/"+this.query).then(response => {
                this.dataMonitoringIp = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
				this.loading = false
				
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },

        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getDataMonitoring()
        },

        onPageChange(){
            if (this.loading == false){
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getDataMonitoring()
            }
        },

        onReset(){
            this.input.filterFromDate = null
            this.input.filterToDate = null
            this.input.filterCabang = null
            this.input.filterStatus = null
            this.input.filterLogin = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getDataMonitoring()
        },

        onFilter(){
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true

            if(this.$helper.isNotNullAndNotEmpty(this.input.filterToDate) && !this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)){
                this.$helper.toastErr(this, "Mohon isi tanggal mulai dan tanggal akhir filter!")
            }else if(!this.$helper.isNotNullAndNotEmpty(this.input.filterToDate) && this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)){
                this.$helper.toastErr(this, "Mohon isi tanggal mulai dan tanggal akhir filter!")
            }else if((this.$helper.isNotNullAndNotEmpty(this.input.filterToDate) && this.$helper.isNotNullAndNotEmpty(this.input.filterFromDate)) && (Date.parse(this.input.filterToDate) < Date.parse(this.input.filterFromDate))){
                this.$helper.toastErr(this, "Tanggal akhir lebih kecil daripada tanggal mulai!")
            }else{
                this.getDataMonitoring()
            }
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
		},
		
		confirmRead(id){
			this.activeId = id
			this.$bvModal.show("modal-confirm-markAsRead")
		},

		onSubmit(){
            this.isSubmitting = true
            this.$axios.post(`monitoring-ip/mark-read?id=${this.activeId}`).then(response => {
                this.$helper.setFlash(`Monitoring telah dibaca!`)
                let idx = this.dataMonitoringIp.findIndex(item => item.id == this.activeId);
				this.dataMonitoringIp[idx].markRead = true
				console.log(response)
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
				this.isSubmitting = false
				this.$bvModal.hide("modal-confirm-markAsRead")
            })
		},

		getUserLog(id){
			this.activeUserLogId = id;
			this.isLoadingLog = true;
			this.$bvModal.show("modal-user-log")

			this.pageUserLog = 0
            this.sizeUserLog = this.input.showUserLog
            this.queryUserLog = this.$helper.makeQuery(this.pageUserLog, this.sizeUserLog)
			
			this.$axios.get(`user/log/${this.activeUserLogId}/${this.queryUserLog}`).then(response => {
                this.dataLog = response.data.data
                this.updateTotalItemUserLog(response.data.total)
                // this.toggleBusy()
                this.isLoadingLog = false
            }).catch(error => {
				console.log(error)
				console.log(error.response.data.reason)
				this.$bvModal.hide('modal-user-log')
				this.$helper.toastErr(this, error.response.data.reason)
			})
			.finally(() => {
				this.isSubmitting = false
				this.isLoadingLog = false
			})

		},

		getAksesLog(){
            this.toggleBusy()
            this.dataLog = []

            if(this.$helper.isNotNullAndNotEmpty(this.filterFromDateUserLog)) this.queryUserLog = this.queryUserLog + "&filterStartDate=" + this.filterFromDateUserLog
            if(this.$helper.isNotNullAndNotEmpty(this.filterToDateUserLog)) this.queryUserLog = this.queryUserLog + "&filterEndDate=" + this.filterToDateUserLog
			
			this.$axios.get(`user/log/${this.activeUserLogId}/${this.queryUserLog}`).then(response => {
                this.dataLog = response.data.data
                this.updateTotalItemUserLog(response.data.total)
         
                this.toggleBusy()
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },

		onLimitChangeUserLog(){
            this.sizeUserLog = this.input.showUserLog
            this.perPageUserLog = this.input.showUserLog
            this.currentPageUserLog = 1
            this.pageUserLog = 0
            this.queryUserLog = this.$helper.makeQuery(0, this.sizeUserLog)
            // this.queryUserLog = this.queryUserLog+"&id="+this.id
            this.getAksesLog()
        },

        onPageUserLogChange(){
            if (this.loading == false) {
                this.pageUserLog = this.currentPageUserLog - 1
                this.queryUserLog = this.$helper.makeQuery(this.pageUserLog, this.sizeUserLog)
                this.getAksesLog()
            }
        },

        onResetUserLog(){
            this.filterFromDateUserLog = null
            this.filterToDateUserLog = null
            this.currentPageUserLog = 1
            this.pageUserLog = 0
            this.queryUserLog = this.$helper.makeQuery(0, this.sizeUserLog)
            this.loading = true
            this.getAksesLog()
        },

        onFilterUserLog(){
            if(!this.$helper.isNotNullAndNotEmpty(this.filterFromDateUserLog) || !this.$helper.isNotNullAndNotEmpty(this.filterToDateUserLog)){
                this.$helper.toastErr(this, "Mohon isi tanggal mulai dan tanggal akhir filter!")
            }else if(Date.parse(this.filterToDateUserLog) < Date.parse(this.filterFromDateUserLog)){
                this.$helper.toastErr(this, "Tanggal akhir lebih kecil daripada tanggal mulai!")
            }else{
                this.pageUserLog = 0
                this.currentPageUserLog = 1
                this.queryUserLog = this.$helper.makeQuery(0, this.sizeUserLog)
                this.loading = true
                this.getAksesLog()
            }
            
        },

		updateTotalItemUserLog(total){
            let limit = null
            let prevLimit = null
            this.perPageUserLog = this.sizeUserLog
            this.rowsUserLog = total
            prevLimit = this.pageUserLog * this.sizeUserLog + 1
            limit = this.pageUserLog * this.sizeUserLog + this.sizeUserLog
            if (limit > this.rowsUserLog) limit = this.rowsUserLog
            this.totalViewTextUserLog = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rowsUserLog + " entri"
		},

		resetModal(){
			this.filterFromDateUserLog = null
            this.filterToDateUserLog = null
            this.currentPageUserLog = 1
			this.pageUserLog = 0
			this.input.showUserLog = 10
		}
		
    },

    created(){
        this.init()
    }
}
</script>
